import React, {useEffect, useState, Fragment} from 'react';
import {Badge, IconButton, Typography, List, ListItem, ListItemText, Divider, Popper, Fade, Paper, ListItemButton} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNavigate } from 'react-router-dom';
import { getUserName } from '../services/auth';
import { getUserNotificationCount, getUserNotifications, markNotificationRead } from '../services/request-api';


const ShowUpNoti = ({ user_extract,  id, open, anchorEl }) => {
    const [noti, setNoti] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        if (!user_extract) return;

        getUserNotifications(user_extract)
            .then(res => setNoti(res))
            .catch(err => console.log(err));
        }, [user_extract]);

    const handleClick = (request_id, id, request_type, author) => {
        markNotificationRead(id).then(res => {}).catch(err => {console.log(err)});
        if (author !== user_extract) {
            navigate(`/request-detail/noti/${request_id}/type/${request_type}`)
        } else {
            navigate(`/assign-detail/noti/${request_id}/type/${request_type}`)
        }
    }

    return (
        <>
        {noti.length > 0 && <Popper id={id} open={open} anchorEl={anchorEl} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={{ border: 1, p: 1, bgcolor: 'background.paper' }}>
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                {noti.map((item) => (
                    <>
                        <ListItem key={item.request_id} alignItems="flex-start" sx = {{backgroundColor: item.is_read === true? "#ffffff" : "#ffb3b3"}}>
                            <ListItemButton onClick={e => handleClick(item.request_id, item.id, item.request_type, item.author)}>
                                <ListItemText
                                    primary={`Order ID: ${item.request_id}`}
                                    secondary={
                                        <Fragment>
                                            <Typography
                                                sx={{ display: 'inline', fontStyle: 'italic'}}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                            >
                                                {item.status} - {item.created_at}
                                            </Typography>
                                        </Fragment>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                        <Divider />
                    </>
                ))}
                </List>
            </Paper>
          </Fade>
        )}
      </Popper>}
        </>
    );
};



const NotiBadge = ({user}) => {
    const [countnoti, setcountnoti] = useState(0)
    const [invisible, setInvisible] = React.useState(false);


    const user_extract = getUserName(user)

    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setOpen((previousOpen) => !previousOpen);
      setInvisible(!invisible);

    };
  
    const canBeOpen = open && Boolean(anchorEl);
    const id = canBeOpen ? 'transition-popper' : undefined;

    useEffect(() => {
        if (!user_extract) return;

        getUserNotificationCount(user_extract).then(res => {setcountnoti(res)}).catch(err => {console.log(err)})
    }, [user_extract]);

    return (
        <>
            <Badge 
                badgeContent={countnoti}
                color="info"
                size = "large"
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
                }}
                overlap="circular"
                max = {10}
                invisible={invisible}
            >
                <IconButton onClick={handleClick}>
                    <NotificationsIcon color="action" fontSize="large" />
                </IconButton>
            </Badge>
            {/* {open && (<ShowUpNoti user_extract={user_extract}/>)} */}
            <ShowUpNoti user_extract={user_extract} id = {id} open = {open} anchorEl = {anchorEl}/>
        </>
    )
}

export default NotiBadge;
